import React, {useState} from 'react';
import axios from "axios";
import useSWR from "swr";
import {ItemSetCard} from "../items/itemSetCard";
import {ItemCard} from "../items/itemCard";
import {Container, Grid, Typography} from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/swiper.min.css";
import "swiper/components/navigation/navigation.min.css"
import "swiper/components/thumbs/thumbs.min.css"

// import Swiper core and required modules
import SwiperCore, {
  Autoplay,Pagination,Navigation
} from 'swiper';
import colorPalette from "../../../../styles/theme/colorPalette";
import {css} from "@emotion/react";

// install Swiper modules
SwiperCore.use([Autoplay,Pagination,Navigation]);

const ItemFeatures = () => {
  return (
      <div css={wrapper} id={'item_features'}>
        <Container>
          <div css={{marginBottom: '32px'}}>
            <Typography variant={'h1'} css={mainTitle}>
              <span>商品の特徴</span>
            </Typography>
          </div>
          <Feature
              key={'healthy'}
              categoryName={'ヘルシー食'}
              code={'healthy'}
              itemType={'糖尿病食'}
              description={
                'エネルギーや塩分を調整したお食事で、全ての商品で塩分2.0g未満に、エネルギーをおかずのみの商品で300kcal未満、\n' +
                'ごはん付きで500kcal未満に調整してあります。(ヘルシー食多めについてはエネルギーをおかずのみの商品で350kcal程度、ごはん付きで600kcal程度に調整しています)\n' +
                '糖尿病・脂質異常症・高血圧・痛風の方向け、メタボ対策、ダイエットにおすすめです。'}
          />
          <Feature
              key={'protein'}
              categoryName={'たんぱく質調整食'}
              code={'protein'}
              itemType={'腎臓病食'}
              description={
                'たんぱく質・カリウム・リン・塩分を抑えたお食事で、全ての商品でたんぱく質を10.0g未満に、塩分を2.0g以下に調整してあります。\n' +
                'たんぱく質・カリウム・リン・塩分の摂取を控える必要のある腎臓病・糖尿病性腎症の方におすすめです。'}
          />
          <Feature
              key={'care'}
              categoryName={'ケア食'}
              code={'care'}
              itemType={'嚥下調整食'}
              description={
                'エネルギーや塩分のコントロールだけでなく、咀嚼・嚥下が困難な方におすすめです。\n' +
                '塩分を2.0g未満に、エネルギーを500kcal未満に調整してあります。'}
          />
        </Container>
      </div>
  );
};

export default ItemFeatures;

const fetcherWithParams = (url, params) => axios.get(url, {params: params}).then(res => res.data);

const Feature = ({categoryName, code, itemType, description, ...custom}) => {
  
  const searchCategoryUrl = `${process.env.NEXT_PUBLIC_API_BASE_URL}/api/v1/items/search_category`
  const {data} = useSWR([searchCategoryUrl, code], (url, params) => fetcherWithParams(url, {
    limit: 5,
    major_category_code: code
  }));
  
  return (
      <div css={[featureWrapper,{marginBottom: '48px', border: `solid 1px ${colorPalette.itemCategories[code]}`}]}>
        <div css={[title,{backgroundColor: `${colorPalette.itemCategories[code]}`, color: 'white'}]}>{ `${itemType}(${categoryName})` }</div>
        <div css={descriptionStyle}>
          {
            description
          }
        </div>
        <div>
          <Swiper
              spaceBetween={20}
              loop={true}
              pagination={{
                "clickable": true
              }}
              initialSlide={2}
              navigation={true}
              breakpoints={{
                "320": {
                  "slidesPerView": 1,
                },
                "640": {
                  "slidesPerView": 2,
                },
                "768": {
                  "slidesPerView": 3,
                },
                "1024": {
                  "slidesPerView": 3,
                }
              }}
              centeredSlides={true}
              autoplay={{
                "delay": 3000,
                "disableOnInteraction": false
              }}
              className="mySwiper"
          >
            {
              data &&
              data.itemData.map((obj, j) => (
                  <SwiperSlide
                      key={`${obj.code}_${j}`}
                  >
                    <div css={{
                      padding: '10px',
                      boxSizing: 'border-box',
                      maxWidth: '300px',
                      margin: '0 auto'
                    }}>
                      <ItemCard data={obj} css={{maxWidth: '300px'}}/>
                    </div>
                  </SwiperSlide>
              ))
            }
          </Swiper>
        </div>
      </div>
  )
}

const featureWrapper = css`
`

const title = css`
  color: white;
  padding: 1rem;
  font-size: 2rem;
  text-align: center;
`

const descriptionStyle = css`
  max-width: 460px;
  margin: 2rem auto;
  line-height: 1.5;
  font-size: 1.6rem;
  padding: 0 2rem;
`

const wrapper = css`
`

const mainTitle = css`
  font-weight: bold;
  color: ${colorPalette.primary};
  padding: 1rem;
`